import get from 'lodash.get';
import { emptyArray, emptyObject } from '../../default-props/empty';
import { createSelector } from 'reselect';

export const getSellerCarriers = (state) => get(state, 'data.carriers', emptyArray);
export const getMarketplaces = (state) => get(state, 'data.marketplaces', emptyArray);
export const getProviders = (state) => get(state, 'data.labelProviders', emptyArray);
export const getAllTheCarriers = (state) => get(state, 'data.allTheCarriers', emptyArray);
export const getServiceClassifications = (state) => get(state, 'data.serviceClassifications', emptyArray);
export const getCountries = (state) => get(state, 'data.countries', emptyArray);
export const getStates = (state) => get(state, 'data.states', emptyArray);
export const getFulfillmentProviders = (state) => get(state, 'data.fulfillmentProviders', emptyArray);

const selectSellerCarrierById = (state, props) => get(state, 'data.carriers', []).find((carrier) => carrier.carrierId === props.carrierId);
export const selectCarrierConfirmationsById = (state, props) => get(selectSellerCarrierById(state, props), 'confirmations', emptyArray);

export const getServiceReference = (state) => get(state, 'data.serviceReference', emptyArray);
export const getServiceReferenceLookup = createSelector(getServiceReference, (services) => {
  if (!services || services.length === 0) {
    return emptyObject;
  }
  const lookup = {};
  for (const service of services) {
    lookup[service.serviceId] = service;
  }
  return lookup;
});
